<template>
  <div class="con">
    <div class="title">
      <h2>결제</h2>
      <p><br /></p>
    </div>
    <progress-bar></progress-bar>
    <div class="mt-50">
      <div class="apply-fieldset">
        <div class="apply-program-wrap">
          <div class="apply-select-number">
            선택한 클래스
            <span v-if="sessionData.classList" class="txt-red"
              >({{ subjectLength }})</span
            >
            <button class="pointer" @click="moveSelectPage()">
              다시 선택하기
            </button>
          </div>
          <div class="apply-program-select">
            <ul>
              <div v-for="(classItem, idx) of sessionData.classList" :key="idx">
                <!-- 선택 했을 경우 -->
                <li
                  class="program-select blue"
                  v-for="(item, index) of classItem.subjectList"
                  :key="index"
                >
                  <div class="apply-program-unit">
                    <ul>
                      <!-- 선택한 컬러로 클래스 노출, class="blue" -->
                      <li
                        class="unit-title blue"
                        data-toggle="modal"
                        data-target="#program-info"
                      >
                        <h4 class="pay-title" @click="openModal(item)">
                          {{ item.subjectName }}
                        </h4>
                        <img
                          src="../../assets/img/close.png"
                          class="pointer"
                          alt=""
                          @click="deleteClass(index)"
                        />
                      </li>
                      <li>
                        <p
                          v-for="(item, index) of viewItemList(item)"
                          :key="index"
                        >
                          <span
                            >{{ item.key || "-" }}
                            <b class="bold">{{ item.value || "-" }}</b></span
                          >
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>
              </div>
            </ul>
          </div>
        </div>
        <div class="hq-table-row">
          <h3>신청자 정보</h3>
          <table>
            <colgroup>
              <col width="30%" />
              <col width="70%" />
            </colgroup>
            <tbody>
              <tr v-for="(item, index) of info" :key="index">
                <th>{{ item.item_name }}</th>
                <td>{{ item.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="hq-table-row">
          <h3>결제 정보</h3>
          <table>
            <colgroup>
              <col width="30%" />
              <col width="70%" />
            </colgroup>
            <tbody>
              <tr>
                <th>결제금액</th>
                <td>{{ totalPayment }}원</td>
              </tr>
              <tr>
                <th>결제방법</th>
                <td>
                  <label for="card" v-show="payWay.pay_way === 'C'">
                    <input
                      type="radio"
                      v-model="payType"
                      name="payTypeC"
                      id=""
                      value="card"
                    />
                    <span class="txt-13px ml-05 mr-20">카드결제</span>
                  </label>
                  <label for="pay" v-show="payWay.pay_way === 'A'">
                    <input
                      type="radio"
                      v-model="payType"
                      name="payTypeA"
                      id=""
                      value="trans"
                    />
                    <span class="txt-13px ml-05 mr-20">실시간 계좌이체</span>
                  </label>
                  <label for="pay" v-show="payWay.pay_way === 'D'">
                    <input
                      type="radio"
                      v-model="payType"
                      name="payTypeD"
                      id=""
                      value="card"
                    />
                    <span class="txt-13px ml-05 mr-20">카드결제</span>
                    <input
                      type="radio"
                      v-model="payType"
                      name="payTypeD"
                      id=""
                      value="trans"
                    />
                    <span class="txt-13px ml-05 mr-20">실시간 계좌이체</span>
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="hq-table-row">
          <h3>약관 동의</h3>
          <div class="payment-terms">
            <button
              type="button"
              class="terms-row terms-row-all"
              @click="toggleAllTerms"
            >
              <span class="terms-row-left">
                <span
                  class="terms-check"
                  :class="{ checked: areAllTermsChecked }"
                ></span>
                <span class="terms-label">전체 동의</span>
              </span>
            </button>
            <div class="terms-divider"></div>
            <div v-for="term in terms" :key="term.key" class="terms-row-wrap">
              <button
                type="button"
                class="terms-row"
                @click="toggleTerm(term.key)"
              >
                <span class="terms-row-left">
                  <span
                    class="terms-check"
                    :class="{ checked: agreedTerms[term.key] }"
                  ></span>
                  <span class="terms-label">[필수] {{ term.label }}</span>
                </span>
                <span
                  class="terms-view"
                  @click.stop="openTermsModal(term)"
                  role="button"
                  tabindex="0"
                  @keydown.enter.prevent="openTermsModal(term)"
                >
                  보기
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-agree-btn">
      <button
        type="button"
        :class="setButtonColor()"
        @click="applyByTossPayments()"
      >
        {{ isFinishPage ? "수강신청 하기" : "다음" }}
      </button>
    </div>
    <detail-process
      v-if="isDetailModalOpened"
      :parentData="parentData"
      @close="closeModal()"
    ></detail-process>
    <transition name="modal" appear>
      <div
        v-if="isTermsModalOpened"
        class="terms-modal-overlay"
        @click="closeTermsModal"
      >
        <div class="terms-modal-panel" @click.stop>
          <div class="terms-modal-header">
            <h3>{{ activeTerm.title || activeTerm.label }}</h3>
            <button
              type="button"
              class="terms-modal-close"
              @click="closeTermsModal"
            >
              닫기
            </button>
          </div>
          <div class="terms-modal-body">
            <div
              v-if="activeTerm.content"
              class="terms-modal-content"
              v-html="activeTerm.content"
            ></div>
            <div v-else class="terms-modal-empty">
              약관 내용을 전달받으면 여기에 표시됩니다.
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";
import DetailProcess from "@/components/reg/select/detailModal.vue";
import { RouterLink } from "vue-router";
import { TOSS_PAYMENT_CLIENT_KEY } from "@/utils/constants";

const EventBus = new Vue();
const IMPCODE_APPLY = "imp28895051"; // Carrotglobal Iamport 실제 IMP코드

const PGCODE_F = "kicc.IM000066"; // 글로벌 면세
const PGCODE_T = "kicc.IM000065"; // 글로벌 과세

const solutions_PGCODE_F = "kicc.IM000106"; // 솔루션 면세
const solutions_PGCODE_T = "kicc.IM000105"; // 솔루션 과세

const PGCODE_F_TEST = "kicc.T5102001"; // 글로벌 면세
const PGCODE_T_TEST = "kicc.T5102001"; // 글로벌 과세

const solutions_PGCODE_F_TEST = "kicc.T5102001"; // 솔루션 면세
const solutions_PGCODE_T_TEST = "kicc.T5102001"; // 솔루션 과세

export default {
  components: {
    DetailProcess,
  },
  data: () => ({
    sessionData: {}, // 세션 스토리지 수강신청 등록 전체 데이터
    info: [], // 전 페이지에서 사용자 정보 입력된 데이터
    payWay: {}, // 지불 방법
    totalPayment: 0, // 결제 최종 금액
    payType: "card", // card: 카드결제, trans: 실시간 계좌이체

    merchantUid: "", // api 결제 승인났을때 고유 아이디 받음 (이 아이디로 iamport에 사용)
    orderId: "", // 주문 id
    impUid: "", // imp id
    isDetailModalOpened: false, // 클래스 상세보기 레이어팝업 on/off
    parentData: {}, // 레이어팝업에 전달할 해당 강의 데이터
    mainIdx: "",

    payWayP: "C", // 지불 방법
    partialPay: "A", // 전체결제 A 부분결제 P
    taxType: "T", // 과세 T, 면세 F
    pgCodeType: "inicis",
    isFinishPage: false, // 현재 페이지가 마지막 페이지인지
    subjectLength: 0,
    pageIdx: "",
    agreedTerms: {
      termsOfUse: false,
      privacy: false,
    },
    isTermsModalOpened: false,
    activeTerm: {},
    terms: [
      {
        key: "termsOfUse",
        label: "이용약관 동의 및 환불규정",
        title: "이용약관 동의 및 환불규정",
        link: "https://carrotglobal.com/termsOfUse",
        content: `제 1 조(목적)
이 약관은 ㈜캐럿글로벌(이하 회사라 칭함)에서 제공하는 영어교육 서비스를 이용함에 있어 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.

제 2 조(정의)
이용자 : 이용자란 웹사이트에 접속하여 이 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.

회원 : 회원이란 회사에 개인정보를 제공하여 회원등록을 한 자로서, 회사의 서비스를 지속적으로 제공받으며, 회사가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.

비회원 : 비회원이라 함은 회원에 가입하지 않고 회사가 제공하는 서비스를 이용하는 자를 말합니다.

수강신청 : 수강신청이란 회원이 회사에서 제공하는 온라인 유/무료 서비스를 이용하기 위하여 회사가 정한 별도의 기준 및 절차에 따라 이용을 신청하는 것을 의미합니다.

수강료 : 회사가 제공하는 유료강의를 이용하기 위한 대가로 회사가 정한 별도의 요금체계에 의해 특정기간 단위로 부과 되는 금액을 의미합니다.

수강승인 : 회원이 회사에게 수강신청을 요구하고 회사가 유/무료강의 이용을 승인하는 것을 의미합니다.

제 3 조(약관의 명시와 개정)
캐럿글로벌은 이 약관의 내용과 상호, 영업소, 소재지, 대표자의 성명, 사업자등록번호, 연락처(전화, 팩스, 전자우편 주소 등) 등을 이용자가 알 수 있도록 캐럿글로벌 웹사이트에 게시합니다.

캐럿글로벌은 약관의 구제등에 관한 법률, 전자거래기본법, 전자 서명 법, 정보통신망이용촉진등에 관한 법률, 방문판매등에 관한 법률, 소비자보호법 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.

캐럿글로벌이 이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 캐럿글로벌 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.

캐럿글로벌이 이 약관을 개정할 경우에는 그 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정전의 약관조항이 그대로 적용됩니다. 다만 이미 계약을 체결한 이용자가 개정 약관 조항의 적용을 받기를 원하는 뜻을 제3항에 의한 개정약관의 공지기간 내에 캐럿글로벌에 송신하여 캐럿글로벌의 동의를 받은 경우에는 개정약관 조항이 적용됩니다.

"회원"은 변경된 약관이 공지된 후 15일 이내에 변경된 약관에 대한 거부의사를 표명할 수 있으며 "회원"이 거부의사를 표명할 경우 캐럿글로벌은 "회원"과의 계약을 해지할 수 있습니다. 만약 "회원"이 변경된 약관이 공지된 후 15일 이내에 거부의사를 표시하지 않는 경우에는 변경된 약관에 동의하는 것으로 간주합니다.

이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 정부가 제정한 전자거래소비자보호지침 및 관계법령 또는 상관례에 따릅니다.

제 4 조(서비스의 제공 및 변경)
캐럿글로벌은 다음과 같은 업무를 수행합니다.
1. 학습정보 제공과 유/무료 서비스 정보제공 및 구매계약의 체결
2. 구매계약이 체결된 온라인 유/무료 서비스 제공
3. 기타 회사가 정하는 업무

캐럿글로벌은 회사가 제공하는 서비스 및 기술적 사양 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 서비스 내용을 변경할 수 있습니다. 이 경우에는 변경된 서비스의 내용 및 제공일자를 명시하여 현재의 재화및 용역의 내용을 게시한 곳에 그 제공일자 이전 7일부터 공지합니다.

캐럿글로벌이 제공하기로 이용자와 계약을 체결한 서비스의 내용을 회사의 내부적인 사유로 변경할 경우에는 캐럿글로벌은 이로 인하여 이용자가 입은 손해를 배상합니다. 단, 캐럿글로벌의 고의 또는 과실이 없는 경우에는 그러하지 아니합니다.

제 5 조(서비스의 중단)
캐럿글로벌은 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.

제 1항에 의한 서비스 중단의 경우에는 캐럿글로벌은 제 8조에 정한 방법으로 이용자에게 통지합니다.

캐럿글로벌은 제 1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제 3자가 입은 손해에 대하여 배상합니다. 단, 캐럿글로벌의 고의 또는 과실이 없는 경우에는 그러하지 아니합니다.

제 6 조(회원가입)
이용자는 이 약관에 동의한다는 의사표시를 한 후 회사가 정한 가입 양식에 따라 회원정보를 기입함으로써 회원가입을 신청합니다.

캐럿글로벌은 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 온라인 및 모바일회원으로 등록합니다.
1. 가입신청자가 이 약관 제7조 제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 다만 제7조 제3항에 의한 회원자격 상실 후 3년이 경과한 자로서 캐럿글로벌의 회원 재가입 승낙을 얻은 경우에는 예외로 한다.
2. 등록내용에 허위, 기재누락, 오기가 있는 경우
3. 기타 회원으로 등록하는 것이 캐럿글로벌의 기술상 현저한 지장이 있다고 판단되는 경우

회원가입계약의 성립시기는 캐럿글로벌의 승낙이 회원에게 도달한 시점으로 합니다.

회원은 제 15조 제 1항에 의한 등록사항에 변경이 있는 경우, 즉시 전자우편, 기타 방법으로 캐럿글로벌에 그 변경사항을 알려야합니다.

제 7 조(회원탈퇴 및 자격 상실 등)
회원은 캐럿글로벌에 언제든지 탈퇴를 요청할 수 있으며 캐럿글로벌은 즉시 회원탈퇴를 처리합니다.

회원이 다음 각 호의 사유에 해당하는 경우, 캐럿글로벌은 회원자격을 제한 및 정지시킬 수 있습니다.
1. 가입 신청 시에 허위 내용을 등록한 경우
2. 캐럿글로벌을 이용하여 구입한 재화, 용역 등의 대금, 기타 캐럿글로벌 이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우
3. 다른 사람의 캐럿글로벌 이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우
4. 캐럿글로벌을 이용하여 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우

캐럿글로벌이 회원자격을 제한, 정지 시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 캐럿글로벌은 회원자격을 상실 시킬 수 있습니다.

캐럿글로벌이 회원자격을 상실 시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에 소명할 기회를 부여합니다.

제 8 조(회원에 대한 통지)
캐럿글로벌은 회원에 대한 통지를 하는 경우, 회원이 캐럿글로벌에 제출한 전자우편 주소 및 SMS로 할 수 있습니다.

캐럿글로벌은 불특정다수 회원에 대한 통지의 경우 1주일이상 캐럿글로벌 게시판에 게시 함으로서 개별 통지에 갈음할 수 있습니다.

제 9 조(수강신청)
회원은 캐럿글로벌이 지정한 수강신청서를 작성, 제출함으로써 온라인 유/무료 강의를 수강신청 할 수 있습니다.

캐럿글로벌은 수강신청에 대하여 다음 각 호에 해당하지 않는 한 수강신청을 승낙합니다.
1. 신청 내용에 허위, 기재누락, 오기가 있는 경우
2. 수강신청에 승낙하는 것이 캐럿글로벌 기술상 현저히 지장이 있다고 판단하는 경우

제 10 조(수강료의 납부)
회원은 캐럿글로벌이 제공하는 온라인 유료강의를 수강하기 위해서는 지정된 수강료를 지불해야만 합니다.

수강료는 캐럿글로벌이 지정한 요금체계에 의하며 캐럿글로벌에 공지한 가격을 기준으로 합니다.

수강료 지급방법은 다음 각 호의 하나로 할 수 있습니다.
1. 신용카드 결제
2. 무통장 입금
3. 온라인 계좌이체
4. 네이버 페이
5. 카카오 페이

제 11 조(수신확인통지, 수강신청 변경 및 취소)
캐럿글로벌은 회원의 수강신청이 있는 경우 회원에게 수신확인 통지를 합니다.

수신확인통지를 받은 회원은 의사표시의 불일치 등이 있는 경우에는 수신확인 통지를 받은 후 즉시 수강신청 변경 및 취소를 요청 할 수 있습니다.

캐럿글로벌은 수강승인 전 회원의 수강신청 변경 및 취소 요청이 있는 때에는 지체 없이 그 요청에 따라 처리합니다.

제 12 조(수강승인)
캐럿글로벌은 회원으로부터 지정된 수강료 입금이 확인되는 즉시, 수강료를 지불한 유료강의에 대한 수강을 승인합니다.

캐럿글로벌은 회원이 신용카드 및 온라인 계좌이체, 유/무선 전화결제, Cyberpass, ICash로 수강료를 지급할 경우, 결제완료와 동시 에 수강료를 지불한 유료강의에 대한 수강을 즉시 승인합니다.

캐럿글로벌은 회원이 무통장 입금으로 수강료를 지급할 경우, 수강료 입금확인과 동시에 수강료를 지불한 유료강의에 대한 수강을 즉 시 승인합니다.

캐럿글로벌은 회원의 수강신청에 따른 승인이 이루어졌을 경우, 이를 회원에게 통지합니다.

수강이 승인된 정해진 관리system 의해서 학습을 시작할 수 있으며, 지정된 학습기간이 종료된 후에는 별도의 재학습 기간을 제공해 드리지 않고 있습니다.

제 13 조(수강취소 및 환불)
환불의 규정은 아래와 같으며 이는 평생교육 사업법에 의거하여 규정되었습니다.

전화강의 서비스 이용료 징수기간이 1개월 이내인 경우
1) 수업시작 전 - 기납입한 이용료 전액
2) 총 수업시간의 1/3이 경과하기 전 - 기납입한 이용료의 2/3에 해당되는 금액
3) 총 수업시간의 1/2이 경과하기 전 - 기납입한 이용료의 1/2에 해당되는 금액
4) 총 수업시간의 1/2이 경과한 후 - 반환하지 아니함

전화강의 서비스 이용료 징수기간이 1개월을 초과하는 경우
1) 수업시작 전 - 기납입한 이용료 전액
2) 수업시작 후 - 환불사유가 발생한 그 달의 환불대상 이용료 (이용료 징수기간이 1개월 이내인 경우에 준하여 산출된 이용료)와 나머지 달의 이용료 전액을 합산한 금액 )
단, 장기수강에 따른 할인율이 적용된 경우, 환불사유 적용시점에서 수업이 완료된 개월에 대해 할인액을 재적용하여 환불전 적용된 할인액과의 차액을 환불금액에서 차감합니다.

단, 재적용되는 할인액은 신청한 상품의 수강신청페이지상에서 완료된 개월에 준한 할인율을 기준으로 합니다.

네이버페이를 통한 주문건의 경우, 전화강의 서비스 이용료 지불 후 29일을 초과하여 환불 시 결제수수료 및 상품 구입 시 지급받은 네이버페이 포인트를 위약금으로 정합니다.

환불금액은 환불 신청 후 일주일 내에 고객님이 요청한 통장으로 입금이 되며, 카드로 결제한 고객분은 교재금액 및 종료된 수업횟수의 수강료를 캐럿글로벌 통장계좌(우리: 1005-404-222447, ㈜캐럿글로벌)로 입금 또는 카드 재결제 완료 후 승인취소가 가능합니다.

제 14 조(개인정보보호)
캐럿글로벌은 이용자의 정보수집 시 구매계약 이행에 필요한 최소한의 정보를 수집합니다. 다음 사항을 필수사항으로 하며 그 외 사항 은 선택사항으로 합니다.
1. 성명
2. 주소(국내 거주자에 한함)
3. 연락처
4. 희망 ID
5. 비밀번호
6. e-mail 주소

캐럿글로벌은 이용자의 개인식별이 가능한 개인정보를 수집하는 때에는 반드시 당해 이용자의 동의를 받습니다.

제공된 개인정보는 당해 이용자의 동의 없이 목적 외의 이용이나 제3자에게 제공할 수 없으며, 이에 대한 모든 책임은 캐럿글로벌이 집니다. 다만, 다음의 경우에는 예외로 합니다.
1. 서비스 협력 업체와 학사관리에 필요한 최소한의 이용자 정보(성명, e-mail 주소)를 알려주는 경우
2. 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우

캐럿글로벌은 제2항과 제3항에 의해 이용자의 동의를 받아야 하는 경우에는 개인정보관리 책임자의 신원(소속, 성명 및 전화번호 기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공 관련사항(제공받는 자, 제공 목적 및 제공할 정보의 내용) 등 정보통신망이용촉진법에 관한 법률 제16조 제3항이 규정한 사항을 미리 명시하거나 고지해야 하며 이용자는 언제든지 이 동의를 철회할 수 있습니다.

이용자는 언제든지 캐럿글로벌이 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며 캐럿글로벌은 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 캐럿글로벌은 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.

캐럿글로벌은 개인정보 보호를 위하여 관리자를 한정하여 그 수를 최소화하며 신용카드, 은행계좌 등을 포함한 이용자의 개인정보의 분실, 도난, 유출, 변조 등으로 인한 이용자의 손해에 대하여 모든 책임을 집니다.

캐럿글로벌 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다.

제 15 조(회사의 의무)
캐럿글로벌은 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적 으로 재화용역을 제공하는데 최선을 다하여야 합니다.

캐럿글로벌은 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한 보안 시스템을 갖추어야 합니다.

캐럿글로벌은 상품이나 용역에 대하여 「표시광고의 공정화에 관한 법률」 제3조 소정의 부당한 표시광고행위를 함으로써 이용자 가 손해를 입은 때에는 이를 배상할 책임을 집니다.

캐럿글로벌은 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.

제 16 조( 회원의 ID 및 비밀번호에 대한 의무)
제15조의 경우를 제외한 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.

회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.

회원이 자신의 ID 및 비밀번호를 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 캐럿글로벌에 통보하고 캐럿글로벌의 안내가 있는 경우에는 그에 따라야 합니다.

제 17 조(이용자의 의무)
이용자는 다음 행위를 하여서는 안됩니다.
1. 신청 또는 변경 시 허위내용의 등록
2. 캐럿글로벌에 게시된 정보의 변경
3. 캐럿글로벌이 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시
4. 캐럿글로벌 기타 제3자의 저작권 등 지적재산권에 대한 침해
5. 캐럿글로벌 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위
6. 외설 또는 폭력적인 메시지화상음성 기타 공서양속에 반하는 정보를 캐럿글로벌에 공개 또는 게시하는 행위

제 18 조(캐럿글로벌과 연결사이트 간의 관계)
캐럿글로벌과 연결 사이트란 하이퍼 링크(예 : 하이퍼 링크의 대상에는 문자, 그림 및 동화상등이 포함됨)방식 등으로 연결된 경우를 말합니다.

캐럿글로벌은 연결 사이트가 독자적으로 제공하는 서비스에 의하여 이용자와 행하는 거래에 대해서 보증책임을 지지 않습니다.

제 19 조(저작권의 귀속 및 이용제한)
캐럿글로벌이 작성한 저작물에 대한 저작권 기타 지적재산권은 캐럿글로벌에 귀속됩니다.

이용자는 캐럿글로벌을 이용함으로써 얻은 정보를 캐럿글로벌의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리 목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.

제 20 조(분쟁해결)
캐럿글로벌은 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치 운영합니다.

캐럿글로벌은 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다.

캐럿글로벌과 이용자간에 발생한 분쟁은 전자거래기본법 제28조 및 동 시행령 제15조에 의하여 설치된 전자거래분쟁조정위원회의 조정에 따를 수 있습니다.

제 21 조(재판권 및 준거 법)
캐럿글로벌과 이용자간에 발생한 전자거래 분쟁에 관한 소송은 민사소송법상의 관할법원에 제기합니다.

캐럿글로벌과 이용자간에 제기된 전자거래 소송에는 한국 법을 적용합니다.

부 칙(시행일)
본 약관은 2001년 2월 13일부터 적용합니다.`,
      },
      {
        key: "privacy",
        label: "개인정보 수집 및 이용 동의",
        title: "개인정보 수집 및 이용 동의",
        link: "https://carrotglobal.com/PrivacyPolicy",
        content: `캐럿글로벌(이하 캐럿 또는 회사라고 함)은 개인정보보호법, 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가 지켜야할 관련 법령상의 개인정보보호 규정을 준수하고 있습니다. 당사의 개인정보처리방침은 정부의 법률/지침 변경 혹은 캐럿의 약관 및 내부 정책에 따라 변경될 수 있으며, 이를 개정/변경하는 경우 당사의 홈페이지에 변경사항을 즉시 게시하고 있습니다.
본 개인정보처리방침의 목차는 아래와 같습니다.
1. 수집하는 개인정보의 항목 및 수집방법
2. 개인정보의 수집 및 이용목적
3. 개인정보의 보유 및 이용기간
4. 개인정보의 파기절차 및 방법
5. 개인정보
6. 수집한 개인정보의 위탁
7. 이용자 및 법정대리인의 권리와 그 행사방법
8. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항
9. 개인정보 위탁 현황
10. 개인정보 보호 책임자
11. 고지의 의무
1. 수집하는 개인정보의 항목 및 수집방법
캐럿은 온라인 및 모바일 회원가입, 상담, 서비스 신청 등등을 위해 아래와 같은 개인정보를 수집하고 있습니다.

가. 수집하는 개인정보 항목
1) 회원
최초 회원가입 시 회원식별 및 최적화된 서비스 제공을 위해 아래와 같은 정보를 수집합니다.
- 필수항목: 이름, 아이디, 비밀번호, 이메일, 휴대전화
- 선택항목: 영문이름, 주소, 일반전화
2) 비회원
무료수업 신청, 비회원 구매, 학습문의 시 아래와 같은 정보를 수집합니다.
- 필수항목 : 이름, 이메일, 휴대전화
- 선택항목 : 추천인 명
3) 서비스 이용과정이나 사업 처리과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다.
- 웹사이트 이용 시: 서비스 이용기록, 접속로그, 쿠키, 접속IP정보, 결제기록
- 모바일 이용 시: 서비스 이용 기록, 접속 로그, 기기고유번호(디바이스 아이디 또는 IMEI)
4) 고객 상담 시 서비스 품질 향상을 위해 담당자 연결 후 통화내용이 녹음되어 아래와 같은 정보들을 수집합니다.
- 통화이력 및 녹음 파일
5) 수업 복습 컨텐츠를 위해 수업 내용이 녹음/녹화되어 정보를 수집합니다.

나. 수집방법
1) 홈페이지를 통한 회원가입, 서비스 이용 결제, 이벤트 응모, 전화, 팩스, 고객센터 문의 및 상담
2) 생성정보 수집 툴을 통한 수집

2. 개인정보의 수집 및 이용목적
캐럿은 수집한 개인정보를 다음의 목적을 위해 활용합니다.

ο 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산 콘텐츠 제공, 구매 및 요금 결제, 본인인증, 물품배송 또는 청구지 등 발송

ο 회원 관리
회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지,
가입 의사 확인, 연령확인, 불만처리 등 민원처리, 고지사항 전달

ο 마케팅 및 광고에 활용
신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재,
접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계

ο 기타
가입횟수 제한, 분쟁조정을 위한 기록보존 및 기타 통계자료 산출

3. 개인정보의 보유 및 이용기간
회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다.
파기절차 및 방법은 다음과 같습니다.

ο 파기절차:회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후
별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한
정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다.
별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.
ο 파기방법:전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.
ο 보유기간:이용계약에 따른 회원자격이 유지되는 기간동안
그러나 회원탈퇴 후에도 관계법령의 규정에 의하여 보존할 필요가 있는 경우 캐럿은 아래와 같이 일정 기간동안 회원정보를 보관합니다.
회원 및 비회원 통화 이력은 상담 종료 후 30일동안 보관된 후 파기됩니다.

4. 개인정보의 파기절차 및 방법
개인정보의 보유 및 이용기간은 다음과 같습니다.

ο 보유항목:수집항목과 같습니다.
ο 보유근거:이용약관 및 개인정보취급방침
ο 보유기간:이용계약에 따른 회원자격이 유지되는 기간동안 그러나 회원탈퇴 후에도 관계법령의 규정에 의하여
보존할 필요가 있는 경우 캐럿은 아래와 같이 일정 기간동안 회원정보를 보관합니다.
표시/광고에 관한 기록 : 6개월 (전자상거래등에서의 소비자보호에 관한 법률)
계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)
대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)
소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)
신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)
통신비밀보호법에 따른 통신사실확인자료 3개월

5. 개인정보
캐럿은 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.

이용자들이 사전에 동의한 경우
- 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우

6. 이용자 및 법정대리인의 권리와 그 행사방법
이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를
조회하거나 수정할 수 있으며 가입해지를 요청할 수도 있습니다.
이용자 혹은 만 14세 미만 아동의 개인정보 조회를 위해서는 정보수정 을,
가입해지(동의철회)를 위해서는 "회원탈퇴"를 클릭 하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.
혹은 개인정보보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체없이 조치하겠습니다.
귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전 까지 개인정보를 이용 또는 제공하지 않습니다.
또한 잘못된 개인정보를 제3자 에게 이미 제공한 경우에는
정정 처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록 하겠습니다.
캐럿은 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는
캐럿이 수집하는 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고
그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.

7. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항
캐럿은 귀하의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)' 등을 운용합니다.
쿠키란 캐럿의 웹사이트를 운영하는데 이용되는 서버가
귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다.
캐럿은 다음과 같은 목적을 위해 쿠키를 사용합니다.

쿠키 등 사용 목적
- 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적,
각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공

쿠키 설정 거부 방법
- 쿠키 설정을 거부하는 방법으로는 회원님이 사용하시는 웹 브라우저의 옵션을 선택함으로써
모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.
- 설정방법 예(인터넷 익스플로러의 경우): 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보
(단, 귀하께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.)

8. 개인정보 위탁 현황
고객지원 및 서비스 제공을 위해 아래와 같이 개인정보 취급 업무를 외부 업체에 위탁하여 운영하고 있습니다.
위탁계약시 개인정보보호의 안전을 기하기 위하여 개인정보보호 관련 지시 엄수,
개인정보에 관한 유출금지 및 사고시의 책임부담 등을 명확히 규정하고 위탁계약 내용에 포함하고 있습니다.

수탁업체
위탁목적
개인정보 보유 및 이용기간
㈜캐럿솔루션즈
학습관리시스템(LMS) 운영
계약종료 시까지
다우정보기술
학습 관리를 위한 SMS 발송 서비스
계약종료 시까지
CJ대한통운
캐럿글로벌 내 교재 택배 발송
계약종료 시까지
한국도서물류
물류 창고에 있는 교재 발송
계약종료 시까지
디엠도서유통
외부 교재 주문 시 발송 대행 회사
계약종료 시까지
09. 개인정보 보호 책임자
캐럿은 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여
아래와 같이 관련 부서 및 개인정보보호책임자를 지정하고 있습니다.

개인정보보호책임자 성명 : 노상충
전화번호 : 02-518-5467 (평일 : 9시 ~ 6시까지)
이메일 : jamesroh@carrotglobal.com

기타 개인정보 침해에 대한 신고나 상담이 필요한 경우에 아래 기관에 문의 가능합니다.
 개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)
 대검찰청 사이버수사과 (www.spo.go.kr / 국번없이 1301)
 경찰청 사이버수사국 (police.go.kr / 국번없이 182)

10. 고지의 의무
현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는
변경사항 시행일의 7일전부터 고지할 것입니다.

- 공고일자: 2021년 5월 26일`,
      },
    ],

    pointColor: "blue",

    payment: null, // 토스 페이먼트 인스턴스
    isLoading: false, // 결제 로딩 상태
  }),

  watch: {
    // 등록 페이지 내의 현재 라우터 경로 감지
    // Watch에 넣어놓은 이유는 keep-alive 사용으로 페이지 진입후 재진입할때 mount가 안되기 때문
    $route(to) {
      if (this.$route.fullPath === "/user/reg/payment") {
        this.loadSugangData();
      }
    },
  },

  computed: {
    areAllTermsChecked() {
      return Object.values(this.agreedTerms).every(Boolean);
    },
  },

  mounted() {
    this.pointColor = sessionStorage.getItem("pointColor");

    this.loadSugangData();
    //TODO: idx 추후에 변경해야함
    var idx = sessionStorage.getItem("mainIdx");
    this.mainIdx = sessionStorage.getItem("mainIdx");
    var params = {
      idx: idx,
    };
    this.axios
      .get(this.axios.root + this.axios.port + `/sugang/pay-way/${idx}`)
      .then((res) => {
        // console.log('res', res)
        if (res.data.err === 0) {
          this.payWay = res.data.payWay;
          this.taxType = res.data.payWay.tax_type;

          if (this.payWay.pay_way === "C") {
            this.payType = "card";
            this.payWayP = "C";
          } else if (this.payWay.pay_way === "A") {
            this.payType = "trans";
            this.payWayP = "A";
          }

          if (res.data.payWay.partial_pay) {
            this.partialPay = res.data.payWay.partial_pay;
          }
        } else {
          alert(res.data.result);
        }
      });

    var pathArray = this.$route.fullPath.split("/");
    var length = pathArray.length;
    var pageType = pathArray[length - 1];
    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
    var finishPage = pOrder[pOrder.length - 1];

    if (pageType === finishPage) {
      this.isFinishPage = true;
    }

    // 토스 페이
    const script = document.createElement("script");
    script.src = "https://js.tosspayments.com/v2/standard";
    script.onload = this.initializePayment;
    document.head.appendChild(script);
  },

  methods: {
    // 토스 페이먼트 초기화
    initializePayment() {
      const isTest =
        location.href.includes("local") || location.href.includes("stage");

      const clientKey = isTest
        ? TOSS_PAYMENT_CLIENT_KEY.TEST
        : TOSS_PAYMENT_CLIENT_KEY.LIVE;

      const tossPayments = window.TossPayments(clientKey);
      const customerKey = "cust_" + Math.random().toString(36).slice(2);

      this.payment = tossPayments.payment({ customerKey });
    },

    // 토스 페이먼트 클릭 이벤트 추적
    trackClickPayment() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "click_payment",
        product_id: this.sessionData.classList[0].classIdx,
        product_name: this.sessionData.classList[0].className,
        price: this.totalPayment,
      });
    },

    // 수강신청 하기
    async applyByTossPayments() {
      if (!this.areAllTermsChecked) {
        alert("이용약관 및 개인정보 수집 및 이용에 동의해 주세요.");
        return false;
      }

      const self = this;

      if (self.sessionData.classList[0].subjectList.length === 0) {
        alert("선택한 클래스가 1개 이상 있어야 합니다.");
        return false;
      }

      if (self.payType === "card") {
        self.payWayP = "C";
      } else if (self.payType === "trans") {
        self.payWayP = "A";
      }

      var params = [];
      for (var item of self.sessionData.classList) {
        for (var subject of item.subjectList) {
          var tempQuery = {
            bookPriceYN: "Y",
            idxItmSugangPageMain: self.pageIdx,
            idxItmSugangSubject: subject.subjectIdx,
            name: self.name,
            email: self.email,
            payWay: self.payWayP,
            partialPay: self.partialPay,
            status: "N",
            price: subject.eduPrice + subject.bookPrice,
            subjectName: subject.subjectName,
            totalPrice: self.totalPayment,
          };

          if (subject.eduPrice === 0 && subject.bookPrice !== 0) {
            tempQuery["partialPay"] = "B";
          } else if (subject.eduPrice !== 0 && subject.bookPrice === 0) {
            tempQuery["partialPay"] = "C";
          } else {
            tempQuery["partialPay"] = "A";
          }
          params.push(tempQuery);
        }
      }

      if (params[0].name == "") {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      if (params[0].email == "") {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      if (params[0].name == null) {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      if (params[0].email == null) {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      if (typeof params[0].name == "undefined") {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      if (typeof params[0].name == "undefined") {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }

      // 모바일 데이터 localstorage에 저장
      self.storeMobilePayData();
      self.axios
        .post(self.axios.root + self.axios.port + "/pay/check", params)
        .then(async (res) => {
          if (res.data.err === 0) {
            if (this.isLoading) {
              return;
            }

            if (!this.payment) {
              alert("결제 모듈이 초기화되지 않았습니다.");
              return;
            }

            this.trackClickPayment();

            sessionStorage.setItem(
              "paymentUserInfo",
              JSON.stringify(this.info),
            );

            self.merchantUid = res.data.merchantUid;

            const isProduction =
              window.location.host === "apply.carrotglobal.com" ||
              window.location.host === "apply2.carrotglobal.com";
            const noticeUrl = isProduction
              ? "https://apply-api.carrotglobal.com/external/sugang/new/webhook"
              : "https://stage-itmsugang-api.carrotenglish.net/external/sugang/new/webhook";

            self.saveChkTmp(
              res.data.merchantUid,
              "",
              res.data.merchantUid,
              self.totalPayment,
              "/pay/checkTmp",
            );

            // 토스 결제 시작
            this.trackClickPayment();
            this.isLoading = true;

            sessionStorage.setItem(
              "paymentUserInfo",
              JSON.stringify(this.info),
            );

            try {
              const isTaxFree = self.taxType === "F";
              console.log(self.taxType);
              const payload = {
                method: self.payType === "card" ? "CARD" : "TRANSFER",
                amount: {
                  currency: "KRW",
                  value: self.totalPayment,
                },
                orderId: this.sessionData.merchantUid,
                orderName: self.sessionData.classList[0].className,
                successUrl: `${window.location.origin}/paymentRedirect`,
                failUrl: `${window.location.origin}/payment`,
                customerName: this.sessionData.name,
                customerEmail: this.sessionData.email,
              };

              if (isTaxFree) {
                payload.taxFreeAmount = self.totalPayment;
              }

              await this.payment.requestPayment(payload);
            } catch (e) {
              sessionStorage.removeItem("paymentUserInfo");
              alert(e.message || "결제 요청에 실패했습니다.");
              this.isLoading = false;
            }
          } else {
            alert(res.data.result);
          }
        })
        .catch((err) => {
          alert(err);
        });
    },

    async requestPayment() {
      if (this.isLoading) {
        return;
      }

      if (!this.payment) {
        alert("결제 모듈이 초기화되지 않았습니다.");
        return;
      }

      this.trackClickPayment();
      this.isLoading = true;

      sessionStorage.setItem("paymentUserInfo", JSON.stringify(this.info));

      try {
        await this.payment.requestPayment({
          method: "CARD",
          amount: {
            currency: "KRW",
            value: this.totalPayment,
          },
          orderId: this.orderId,
          orderName: this.sessionData.classList[0].subjectList[0].subjectName,

          successUrl: `${window.location.origin}/paymentOk`,
          failUrl: `${window.location.origin}/payment`,

          customerName: this.info[0].value,
          customerEmail: this.info[1].value,

          customerMobilePhone: this.info[2].value.replace(/[^\d]/g, ""),

          card: {
            useEscrow: false,
          },

          taxFreeAmount: this.taxType === "F" ? this.totalPayment : 0,
        });
      } catch (e) {
        sessionStorage.removeItem("paymentUserInfo");
        alert(e.message || "결제 요청에 실패했습니다.");
        this.isLoading = false;
      }
    },

    setButtonColor() {
      if (this.pointColor === "Blue") {
        return "blue";
      } else if (this.pointColor === "Red") {
        return "red";
      } else if (this.pointColor === "Green") {
        return "green";
      }
    },

    toggleAllTerms() {
      const nextValue = !this.areAllTermsChecked;
      this.agreedTerms = {
        termsOfUse: nextValue,
        privacy: nextValue,
      };
    },

    toggleTerm(termKey) {
      this.agreedTerms = {
        ...this.agreedTerms,
        [termKey]: !this.agreedTerms[termKey],
      };
    },

    openTermsModal(term) {
      this.activeTerm = term;
      this.isTermsModalOpened = true;
    },

    closeTermsModal() {
      this.isTermsModalOpened = false;
      this.activeTerm = {};
    },

    // 선택한 클래스 삭제
    deleteClass(idx) {
      this.totalPayment -=
        this.sessionData.classList[0].subjectList[idx].eduPrice +
        this.sessionData.classList[0].subjectList[idx].bookPrice;
      this.sessionData.classList[0].subjectList.splice(idx, 1);
    },

    // 클래스선택 페이지로 이동
    moveSelectPage() {
      this.$router.push("/user/reg/select");
    },

    // 세션 스토리지 수강신청 전체 데이터 loading
    loadSugangData() {
      this.sessionData = JSON.parse(sessionStorage.getItem("classData"));
      this.pageIdx = sessionStorage.getItem("pageIdx");
      this.info = this.sessionData.info;
      this.totalPayment = this.sessionData.totalPayment;

      var count = 0;
      if (this.sessionData.classList) {
        for (var item of this.sessionData.classList) {
          for (var subject of item.subjectList) {
            count += 1;
          }
        }
      }

      this.subjectLength = count;

      for (var item of this.info) {
        if (item.item_name === "이름") {
          this.name = item.value;
        } else if (item.item_name.includes("E-mail@")) {
          this.email = item.value;
        }
      }
    },

    // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
    numberFormat(inputNumber) {
      if (inputNumber) {
        return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "-";
      }
    },

    storeMobilePayData() {
      if (this.sessionData) {
        var mobilePayData = JSON.parse(JSON.stringify(this.sessionData));
        mobilePayData["idxItmSugangPageMain"] =
          sessionStorage.getItem("pageIdx");
        mobilePayData["partialPay"] = this.partialPay;
        mobilePayData["payStatus"] = "Y";
        if (mobilePayData["mobile"]) {
          mobilePayData["mobile"] = mobilePayData["mobile"];
        } else {
          mobilePayData["mobile"] = "";
        }
        mobilePayData["payWay"] = this.payWayP;
        mobilePayData["type"] = "Y";
        mobilePayData["programIdx"] = sessionStorage.getItem("programIdx");

        mobilePayData["studentSubjectIdx"] = -1;

        var itemNames = [
          "이름",
          "비밀번호",
          "사번",
          "휴대전화번호",
          "직급",
          "부서",
          "회사",
          "공인시험점수",
        ];
        var count = 1;

        if (mobilePayData["info"]) {
          for (var item of mobilePayData["info"]) {
            if (item.item_name.includes("E-mail@")) {
              continue;
            } else if (itemNames.includes(item.item_name)) {
              continue;
            } else {
              mobilePayData["optionName" + count.toString()] = item.item_name;
              mobilePayData["optionContents" + count.toString()] = item.value;
              count += 1;
            }
          }
        }

        delete mobilePayData["totalPayment"];

        localStorage.setItem("mobilePayData", JSON.stringify(mobilePayData));
      }
    },
    saveChkTmp(orderId, impUid, merchantUid, amount, url) {
      var infoData = JSON.parse(JSON.stringify(this.sessionData["info"]));

      this.sessionData = {
        ...this.sessionData,
        info: infoData,
        idxItmSugangPageMain: sessionStorage.getItem("pageIdx"),
        partialPay: this.partialPay,
        payStatus: "Y",
        mobile: this.sessionData.mobile ? this.sessionData.mobile : "",
        payWay: this.payWayP,
        amount: amount,
        merchantUid: merchantUid,
        impUid: impUid,
        orderId: orderId,
        type: "Y",
        programIdx: sessionStorage.getItem("programIdx"),
        studentSubjectIdx: -1,
      };

      var itemNames = [
        "이름",
        "비밀번호",
        "사번",
        "휴대전화번호",
        "직급",
        "부서",
        "회사",
        "공인시험점수",
      ];
      var count = 1;

      if (this.sessionData["info"]) {
        for (var item of this.sessionData["info"]) {
          if (item.item_name.includes("E-mail@")) {
            continue;
          } else if (itemNames.includes(item.item_name)) {
            continue;
          } else {
            this.sessionData["optionName" + count.toString()] = item.item_name;
            this.sessionData["optionContents" + count.toString()] = item.value;
            count += 1;
          }
        }
      }

      let params = this.sessionData;

      this.axios
        .post(this.axios.root + this.axios.port + url, params)
        .then(async (res) => {
          if (Number(res.data.err) === 0) {
          } else {
            return false;
          }
        })
        .catch(async (err) => {
          console.error(url + "error : ", err);
          alert("데이터 저장에 실패했습니다.");
        });
    },

    viewItemList(data) {
      if (data.columnOrder) {
        var itemList = data.columnOrder.split("^");
        var returnItemList = [];
        for (var item of itemList) {
          if (item === "언어") {
            returnItemList.push({
              key: item,
              value: data.language,
            });
          } else if (item === "장소") {
            returnItemList.push({
              key: item,
              value: data.place,
            });
          } else if (item === "요일") {
            if (data.day && typeof data.day === "string") {
              returnItemList.push({
                key: item,
                value: data.day.replace(/\^/gi, ""),
              });
            }
          } else if (item === "교육시간") {
            returnItemList.push({
              key: item,
              value: data.subjectStartTime + "~" + data.subjectEndTime,
            });
          } else if (item === "교육비") {
            returnItemList.push({
              key: item,
              value: data.eduPrice,
            });
          } else if (item === "교재비") {
            returnItemList.push({
              key: item,
              value: data.bookPrice,
            });
          }
        }

        return returnItemList;
      } else {
        return [];
      }
    },

    // 클래스 상세보기 레이어팝업 열기
    openModal(data) {
      this.parentData = data;
      this.isDetailModalOpened = true;
    },

    // 모달 닫기
    closeModal() {
      this.isDetailModalOpened = false;
    },
  },
};
</script>
<style scoped>
.terms-divider {
  height: 1px;
  background: #ececec;
}

.terms-row-wrap {
  border-bottom: 1px solid #ececec;
}

.terms-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border: 0;
  background: transparent;
  text-align: left;
}

.terms-row-all {
  padding-bottom: 16px;
}

.terms-row-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.terms-check {
  width: 24px;
  height: 24px;
  border: 2px solid #d9dde5;
  border-radius: 50%;
  position: relative;
  flex: 0 0 24px;
  background: #fff;
}

.terms-check.checked::after {
  content: "";
  position: absolute;
  top: 4px;
  left: 7px;
  width: 6px;
  height: 11px;
  border-right: 2px solid #b6bcc8;
  border-bottom: 2px solid #b6bcc8;
  transform: rotate(45deg);
}

.terms-label {
  color: #4a4f59;
  font-size: 16px;
  font-weight: 600;
}

.terms-view {
  min-width: 56px;
  padding: 8px 14px;
  border-radius: 18px;
  background: #f4f5f7;
  color: #7a808b;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

.terms-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.45);
}

.terms-modal-panel {
  width: 100%;
  max-width: 720px;
  max-height: 80vh;
  border-radius: 18px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.terms-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 24px;
  border-bottom: 1px solid #ececec;
}

.terms-modal-header h3 {
  margin: 0;
  color: #2f3440;
  font-size: 20px;
  font-weight: 700;
}

.terms-modal-close {
  border: 0;
  background: #f4f5f7;
  color: #6f7682;
  border-radius: 16px;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 600;
}

.terms-modal-body {
  max-height: calc(80vh - 77px);
  overflow-y: auto;
  padding: 24px;
}

.terms-modal-content,
.terms-modal-empty {
  color: #4a4f59;
  font-size: 15px;
  line-height: 1.8;
  white-space: pre-wrap;
}

.terms-modal-empty {
  color: #7a808b;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
}

@media all and (max-width: 768px) {
  .payment-terms {
    margin-top: 28px;
  }

  .terms-row {
    padding: 16px 0;
  }

  .terms-label {
    font-size: 14px;
  }

  .terms-modal-overlay {
    padding: 12px;
  }

  .terms-modal-header {
    padding: 18px 16px;
  }

  .terms-modal-header h3 {
    font-size: 18px;
  }

  .terms-modal-body {
    padding: 18px 16px;
  }
}
</style>
